import React, { useState } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { useDispatch } from 'react-redux';
import { updateTripName } from '../../store/actions/mytrips';
import { Color, CommonProperties } from '../../styles';
import BaseText from '../BaseText';
import Icon from '../Icon';
import InputDialog from '../InputDialog';
import RowView from '../RowView';

const TripName = ({ label, editable, id }) => {
  const dispatch = useDispatch();
  const [enableEdit, setEnableEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const onSubmit = async (newName) => {
    setLoading(true);
    await dispatch(updateTripName(id, newName));
    setLoading(false);
    setEnableEdit(false);
  };
  return (
    <RowView style={styles.container}>
      {editable ? (
        <InputDialog
          label="Change Trip Name"
          defaultValue={label}
          visible={enableEdit}
          onCancel={() => setEnableEdit(false)}
          onSubmit={onSubmit}
          loading={loading}
        />
      ) : null}
      <BaseText
        style={{
          ...CommonProperties.h2,
          color: Color.accent,
        }}
      >
        {label}
      </BaseText>
      <TouchableOpacity onPress={() => setEnableEdit(true)}>
        <Icon name="edit" style={styles.icon} />
      </TouchableOpacity>
    </RowView>
  );
};

export default TripName;

const styles = StyleSheet.create({
  container: {
    zIndex: 1,
    ...CommonProperties.p4,
  },
  icon: {
    color: Color.accent,
    fontSize: 24,
    ...CommonProperties.ml3,
  },
});
